module.exports = __webpack_public_path__ + "static/media/upgrand.5cb3b09b.png";